import { render, staticRenderFns } from "./buy-taoka.vue?vue&type=template&id=7865ca48&"
import script from "./buy-taoka.vue?vue&type=script&lang=js&"
export * from "./buy-taoka.vue?vue&type=script&lang=js&"
import style0 from "./buy-taoka.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports